// extracted by mini-css-extract-plugin
export default {"userInfoWrap":"Dashboard_userInfoWrap__TNa8c","label":"Dashboard_label__eRc2r","userLogo":"Dashboard_userLogo__xpOn8","dashboardTitle":"Dashboard_dashboardTitle__QNqJJ"};